import { toPublicLabelUrl } from '../../utils/s3Utils';

/**
 * A courier's system name as the listing shows it: `simpli_route` → `Simpli Route`.
 *
 * @param {string|null} courierStr
 * @returns {string}
 */
export const formatCourier = (courierStr) => {
  if (!courierStr) return '-';
  return courierStr.split('_').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};

/**
 * The label of every delivery item that has one, ready to be fetched.
 *
 * Labels always come from the items: one per bulto. The delivery keeps `label`
 * and `original_label` fields of its own and the backend still writes them for
 * some flows, but they are not what gets printed — reading them would print one
 * label for an order that ships in three boxes.
 *
 * @param {Array<{label?: string}>} deliveryItems
 * @returns {string[]}
 */
export const extractLabelUrls = (deliveryItems) => {
  return deliveryItems
    .map((item) => (item?.label ? toPublicLabelUrl(item.label) : null))
    .filter((url) => url !== null);
};

